// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__36aHe","validationTips":"StatementDescriptor_validationTips__29wZS"};